module.exports = __webpack_public_path__ + "img/04.a282cbe0.png";